export class ListError {
  errorType: number;
  statusMessage: string;
}
